module.exports = __webpack_public_path__ + "img/6.11b1270b.jpg";